import {useIntegrator} from "../../integrator.context";
import {MetadataCollection} from "../../commands/metadataValue.command";
import {AddTechAttributeCommand} from "../../commands/addTechAttribute.command";
import {RemoveTechAttributeCommand} from "../../commands/removeTechAttribute.command";
import MetadataColumn from "../../elements/metadataColumn.element";

function TechEditor() {
    const {state, executeCommand} = useIntegrator();

    return (
        <div className={'layout horizontal flex-grow'} style={{gap: 12, overflowX: 'auto'}}>
            <MetadataColumn title={'Tech Actions'} attributes={state.techActionAttributes} collection={MetadataCollection.TechActions}
                            add={(uid) => executeCommand(new AddTechAttributeCommand(uid, true))}
                            remove={(uid) => executeCommand(new RemoveTechAttributeCommand(uid, true))}/>
            <MetadataColumn title={'Tech Passives'} attributes={state.techPassiveAttributes} collection={MetadataCollection.TechPassives}
                            add={(uid) => executeCommand(new AddTechAttributeCommand(uid, false))}
                            remove={(uid) => executeCommand(new RemoveTechAttributeCommand(uid, false))}
                            allowAdd={false}/>
        </div>
    );
}

export default TechEditor;
